import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { actions as orderActions } from 'state/order';

import TimeErrorModal from 'components/summary/TimeErrorModal/component';

const enhance = compose(
  withTranslation('Summary'),
  connect(() => ({}), {
    navigateToForm: orderActions.navigateToForm,
    discardOrder: orderActions.discardOrder,
  }),
  withProps(({ t }) => ({
    label: t('time_past_error_label'),
    submitLabel: t('time_past_error_button_fix'),
    cancelLabel: t('time_past_error_button_leave'),
  }))
);

export default enhance(TimeErrorModal);
